import React, { useEffect, useRef, useState } from "react";
import DatePicker, { Value } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Stack, Typography } from "@mui/material";
import MuiTextField from "../common/text-field/MuiTextField";
import DateObject from "react-date-object";

interface IMuiTextField {
  name?: string;
  label?: string;
  placeholder?: string;
  value?: Value;
  handleChange?: (value: DateObject | null) => void;
  width?: any;
  sxStyle?: any;
  required?: boolean;
  type?: string;
  labelSx?: string;
  labelColor?: string | any;
}

export default function MuiDatePicker({
  label,
  labelSx,
  labelColor,
  width,
  value,
  handleChange,
}: Readonly<IMuiTextField>) {
  const datePickerRef = useRef<any | null>(null);
  const [isShowCalendar, setIsShowCalendar] = useState<boolean>(false);

  useEffect(() => {
    if (isShowCalendar && datePickerRef.current) {
      datePickerRef.current.openCalendar();
    }
  }, [isShowCalendar]);
  return (
    <div>
      <Stack direction="column" width={width}>
        {label && (
          <Typography
            variant={
              labelSx ? (labelSx as "labelMediumBold") : "labelMediumBold"
            }
            color={
              !labelColor ? (theme) => theme.palette.dominant[400] : labelColor
            }
          >
            {label}
          </Typography>
        )}
        <DatePicker
          ref={datePickerRef}
          calendar={persian} 
          locale={persian_fa}
          format="YYYY/MM/DD" 
          placeholder="انتخاب تاریخ"
          value={
            typeof value === "string" && value
              ? new DateObject({
                  date: new Date(value), 
                  calendar: persian,
                  locale: persian_fa,
                })
              : value || "" 
          }
          onChange={handleChange}
          render={(val, openCalendar) => {
            return <MuiTextField value={val} onBlur={openCalendar} />;
          }}
        />
      </Stack>
    </div>
  );
}
